var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('snack-bar'),_c('confirm-modal',{ref:"modal_confirm"}),_c('report-modal',{ref:"modal_report_problem"}),_c('overlay'),_c('confirm-auth-popup'),_c('SupportMessenger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }